/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {ViewportRuler} from './viewport-ruler';
import {ConnectedPositionStrategy} from './connected-position-strategy';
import {ElementRef, Injectable} from '@angular/core';
import {GlobalPositionStrategy} from './global-position-strategy';
import {OverlayConnectionPosition, OriginConnectionPosition} from './connected-position';
/**
 * Builder for overlay position strategy.
 */
export class OverlayPositionBuilder {
/**
 * @param {?} _viewportRuler
 */
constructor(private _viewportRuler: ViewportRuler) { }
/**
 * Creates a global position strategy.
 * @return {?}
 */
global(): GlobalPositionStrategy {
    return new GlobalPositionStrategy();
  }
/**
 * Creates a relative position strategy.
 * @param {?} elementRef
 * @param {?} originPos
 * @param {?} overlayPos
 * @return {?}
 */
connectedTo(
      elementRef: ElementRef,
      originPos: OriginConnectionPosition,
      overlayPos: OverlayConnectionPosition): ConnectedPositionStrategy {
    return new ConnectedPositionStrategy(elementRef, originPos, overlayPos, this._viewportRuler);
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewportRuler, },
];
}

function OverlayPositionBuilder_tsickle_Closure_declarations() {
/** @type {?} */
OverlayPositionBuilder.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OverlayPositionBuilder.ctorParameters;
/** @type {?} */
OverlayPositionBuilder.prototype._viewportRuler;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
